export enum ProjectSDKCodeStatus {
  INSTALLED = "Installed",
  PENDING = "Pending",
  UNINSTALLED = "Uninstalled",
}
